import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  cancelButtonVariant: 'tertiary'
} satisfies RecursivePartial<DialogConfig['cart']>
